module.exports = __webpack_public_path__ + "img/hi-lai-food.bc90ebc2.png";